import { useEffect, useState } from "react";



export const useIsHardNo = () => {

  const shouldClaimHardNo = () => {
    return window.location.hostname.indexOf("hardno") >= 0
      || window.location.hostname === "localhost";
  }

  const [isHardNo, setIsHardNo] = useState(shouldClaimHardNo() ? true : false);

  useEffect(() => {
    // Someone wrote that window.location.host isn't always available immediately, hence useEffect
    if (shouldClaimHardNo()) {
      setIsHardNo(true);
    }
  }, []);

  return { isHardNo };
}
